module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-0229a2f0.png";